import React, { useContext, useState } from 'react';
import { UserContext } from '../../../App';
import Sidebar from '../Sidebar/Sidebar';
import { useForm } from "react-hook-form";

const MakeAdmin = () => {
    const { loggedInUser } = useContext(UserContext)
    // eslint-disable-next-line no-unused-vars
    const [admin, setAdmin] = useState({})

    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm();


    const onSubmit = (data, e) => {
        // console.log(data);
        fetch("https://immense-inlet-74207.herokuapp.com/setAdmin", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          })
            .then((res) => res.json())
            .then((success) => {
              if (success) {
                alert("Admin Added successfully");
                e.target.value = "";
              }
            });
    }
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-md-3">
                    <Sidebar></Sidebar>
                </div>
                <div className="col-md-9 mt-5">
                    <div className="d-flex justify-content-between">
                        <h2>Add admin</h2>
                        <h4>{loggedInUser.name}</h4>
                    </div>


<form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label>Email</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Email ID"
                        {...register("email", { required: true })}
                      />
                      {errors.name && (
                        <span className="text-danger">
                          This field is required
                        </span>
                      )}
                    </div>
                    <div className="form-group">
                      <label>Password</label>
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter password"
                        {...register("password", { required: true })}
                      />
                      {errors.name && (
                        <span className="text-danger">
                          This field is required
                        </span>
                      )}
                    </div>
                    <button type="submit" className="btn btn-primary">
                      Send
                    </button>
                  </form>
                </div>
            </div>
        </div>
    );
};

export default MakeAdmin;